import { c as _c } from "react/compiler-runtime";
import { CodeBlock } from '@onefootprint/ui';
import formatJson from '../../../utils/format-json';
type JsonViewProps = {
  content: string;
};
const JsonView = t0 => {
  const $ = _c(4);
  const {
    content
  } = t0;
  let t1;
  if ($[0] !== content) {
    t1 = formatJson(content);
    $[0] = content;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t1) {
    t2 = <div className="h-full overflow-auto"><CodeBlock language="json" showLineNumbers={true}>{t1}</CodeBlock></div>;
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
};
export default JsonView;